import { Component } from '@angular/core';
import { Ticket } from '../../../services/http/tickets/tickets.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketService } from '../../../services/http/tickets/tickets.service';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../../services/loader/loader.service';

@Component({
  selector: 'app-comunications-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './comunications-detail.component.html',
  styleUrl: './comunications-detail.component.scss'
})
export class ComunicationsDetailComponent {
  ticketId: string = '';
  ticket: Ticket | undefined;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly ticketService: TicketService,
    private readonly router: Router,
    private readonly loaderService: LoaderService
  ) {
    this.ticketId = this.activatedRoute.snapshot.params['id'];
    this.loaderService.show();
    this.ticketService.getApplicantTicket(this.ticketId).subscribe((ticket) => {
      this.ticket = ticket;
      this.loaderService.hide();
    })
  }

  goBack() {
    this.router.navigate(['comunications']);
  }
}
